import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { BRIGGS_ICE_DEPTH, BRIGGS_ICE } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'

const id = 'BriggsIceDepth'
const authId = 'SmartIce'
const sourceLayer = 'BriggsIceDepth'

export class BriggsIceDepth extends Component {
  componentDidMount () {
    const { map } = this.context
    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('mousemove', id, this.handleMouseMove)
  }

  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    const data = features.map(feature => feature.properties)
    if (data) {
      actions.dataUpdated(data[0], 'hover')
    }
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.hovered !== this.props.hovered) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props    
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (!isEqual(props.hovered, hovered)) {
      if (hovered.id) {
        const filter = ['in', 'id'].concat(props.hovered.id)
        map.setFilter(`${id}Hovered`, filter)
      }
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'vector',
      tiles: [BRIGGS_ICE_DEPTH({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />        
        <Layer
          type='circle'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint}
          />
        <Layer
          id={`${id}Hovered`}
          type='circle'
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={{
            'circle-color': 'rgba(0, 0, 0, 0)',
            'circle-radius': 6,
            'circle-stroke-color': 'white',
            'circle-stroke-width': 2
          }}
          filter={['in', 'id']}
          />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times.WaterLakeTss || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(BriggsIceDepth)



// WEBPACK FOOTER //
// ./src/layers/BriggsIceDepth.js